import { registerPlugin } from '@capacitor/core';
import { SafeAreaInfo } from '../interfaces/safe-area-info';

export interface SafeAreaPlugin {
  getSafeArea(): Promise<SafeAreaInfo>;
  addListener(
    eventName: 'safeAreaDidChange',
    listenerFunc: (info: SafeAreaInfo) => void
  ): Promise<{ remove: () => void }>;
}

const SafeArea = registerPlugin<SafeAreaPlugin>('SafeArea');
export { SafeArea };
